import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/kepler.webp';
import screenshot_target from '../../../images/letterfunnel/harrostokman.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Harro Stokman"
      firstname="Harro"
      companyname="Kepler"
      competition="Nobi en SafelyYou"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/harrostokman.js